import * as actionTypes from "../actionTypes";
import * as ImmersionGQL from "../../../gql";
import { apiClient } from "../../../config/apiClient";
import UtilService from "../../../helper/service";

export const setLoading = (loading: any) => ({
  type: actionTypes.SET_ANALYSIS_LOADING,
  payload: loading
});

const setFetchingScores = (fetching: boolean) => ({
  type: actionTypes.SET_FETCHING_SCORES,
  payload: fetching
});

export const saveCurrentSession = (payload: any) => ({
  type: actionTypes.SAVE_CURRENT_SESSION,
  payload
});

export const initAnalysisData = (loading?: any) => ({
  type: actionTypes.INIT_ANALYSIS_DATA,
  payload: loading
});

export const removeGraphData = (name: string) => ({
  type: actionTypes.REMOVE_GRAPH_DATA,
  payload: {
    activeParticipant: name,
  }
});

export const changeRealTimeGraphType = (type: number) => ({
  type: actionTypes.CHANGE_REALTIME_GRAPH_TYPE,
  payload: type
});

export const removeCliped = () => ({
  type: actionTypes.REMOVE_CLIPED_DATA,
})

export const updateClipedData = (data: any) => ({
  type: actionTypes.UPDATE_CLIPED_DATA,
  payload: data
})

export const updateAnalyzeClipedData = (data: any) => ({
  type: actionTypes.UPDATE_ANALYSE_CLIP_DATA,
  payload: data
})

export const updateSessionRangeByClip = (start: number, end: number) => ({
  type: actionTypes.UPDATE_SESSIOIN_RANGE_BYCLIP,
  payload: {
    start, end
  }
})

export const updateSessionRangeLive = (start: number, end: number) => ({
  type: actionTypes.UPDATE_SESSIOIN_RANGE_LIVE,
  payload: {
    start, end
  }
})

export const getExcludedParticipantsSuccess = (identifiers: any) => ({
  type: actionTypes.GET_EXCLUDED_PARTICIPANTS,
  payload: identifiers
})

export const removeAllParticipant = () => ({
  type: actionTypes.REMOVE_ALL_PARTICIPANT,
})

export const removeAllGraph = () => ({
  type: actionTypes.REMOVE_ALL_GRAPH,
})

export const removeParticipantFromAll = (excludedParticipants: string[]) => ({
  type: actionTypes.REMOVE_PARTICIPANT_FROM_ALL,
  payload: excludedParticipants
});

export const addOverviewToAnalysisKeyMoment = (payload: any) => ({
  type: actionTypes.ADD_OVERVIEW_TO_ANALYSIS_KEY_MOMENT,
  payload
});

export const addVideoLength = (videoLength: any) => ({
  type: actionTypes.ADD_VIDEO_LENGTH,
  payload: videoLength
});

export const updateFullLoadAnalysis = (loaded: boolean) => ({
  type: actionTypes.UPDATE_FULL_LOAD_ANALYSIS,
  payload: loaded
});

export const updateAllParticipantPills = (data: any) => ({
  type: actionTypes.UPDATE_ALL_PARTICIPANT_PILLS,
  payload: data
});

export const updateSettings = (name: string, value: any) => ({
  type: actionTypes.UPDATE_SETTINGS,
  payload: { name, value }
});

export const getXLSXSuccess = (payload: any) => ({
  type: actionTypes.GET_XLSX_SUCCESS,
  payload
});

export const optimizeLiveGraph = () => ({
  type: actionTypes.OPTIMIZE_LIVE_GRAPH,
});

export const setFingerPulseToggle = (value: any) => ({
  type: actionTypes.SET_FINGER_PULSE,
  payload: value
});

export const getIdentifiers = (client: any, session_code: string, isAttendCalculate?: boolean) => {
  return (dispatch: any) => {
    client.query({
      query: ImmersionGQL.queryGetSessionParticipantsCode,
      fetchPolicy: "no-cache",
      variables: {
        session_code
      }
    }).then((res: any) => {
      if (res.data && res.data.getSessionParticipantsCode) {
        dispatch({
          type: actionTypes.GET_IDENTIFIERS,
          payload: res.data.getSessionParticipantsCode,
          isAttendCalculate
        });
      }
    }).catch(() => {

    })
  }
};

export const getIdentifiersCallback = (client: any, session_code: string, isAttendCalculate: boolean, cb: any) => {
  return (dispatch: any) => {
    client.query({
      query: ImmersionGQL.queryGetSessionParticipantsCode,
      fetchPolicy: "no-cache",
      variables: {
        session_code
      }
    }).then((res: any) => {
      if (res.data && res.data.getSessionParticipantsCode) {
        dispatch({
          type: actionTypes.GET_IDENTIFIERS,
          payload: res.data.getSessionParticipantsCode,
          isAttendCalculate
        });
        cb(res.data.getSessionParticipantsCode)
      }
    }).catch(() => {

    })
  }
};

export const getAllAnalysisModerated = async (
  request: any,
  tenant_id: string,
  session_code: string,
  name: string,
  session_status: string,
  isAll: boolean,
  isFilter: boolean,
  isTag: boolean,
  isDisabledCall: boolean,
  cliped?: any
) => {
  return async (dispatch: any) => {

    const { pathname } = window.location;
    dispatch(setFetchingScores(true));
    isFilter && dispatch(setLoading(isAll ? 'all' : isTag ? name : request.identifiers[0]));
    const type = 'sync';
    const status = session_status === 'LIVE' ? 'aggregate' : 'analysis';
    const counts = request.to_epoch - request.from_epoch
    const isCountable = (!isFilter && session_status === 'LIVE') ? `?count=${counts < 5 ? 5 : counts}` : '';

    const clipedRequest = { ...request, from_epoch: cliped?.start_clip, to_epoch: cliped?.end_clip };

    try {
      let safety: any = { data: [] };
      let pills: any = { data: [] };
      let overall_safety: any = null;
      let overall_immersion: any = null;
      let immersion: any = null;

      if (pathname.includes('/creator/experience-manager/analyze') || pathname.includes('/creator/experience-manager/overview')) {
        immersion = await apiClient(true).post(`/${status}/v2/${type}/immersion/${tenant_id}/${session_code}${isCountable}`, { ...request });
      }

      if (session_status === 'COMPLETED') {
        overall_immersion = await apiClient(true).post(`/${status}/v2/${type}/index/immersion/${tenant_id}/${session_code}`, { ...cliped ? clipedRequest : request });
        overall_safety = await apiClient(true).post(`/${status}/v2/${type}/index/safety/${tenant_id}/${session_code}`, { ...cliped ? clipedRequest : request });

        if (pathname.includes('/creator/experience-manager/analyze') || pathname.includes('/creator/experience-manager/overview')) {
          [safety, pills] = await Promise.all([
            apiClient(true).post(`/${status}/v2/${type}/psych-readiness/${tenant_id}/${session_code}`, { ...request }),
            apiClient(true).post(`/${status}/v2/${type}/pills/${tenant_id}/${session_code}`, { ...request })
          ]);
        }

        safety = safety?.data.filter((item: any) => item.immersion_index !== 1)
      } else {
        const overall_request = { ...request, from_epoch: request.session_started_at }
        overall_immersion = await apiClient(true).post(`/${status}/v2/${type}/index/immersion/${tenant_id}/${session_code}`, { ...overall_request });
        overall_safety = await apiClient(true).post(`/${status}/v2/${type}/index/safety/${tenant_id}/${session_code}`, { ...overall_request });
      }

      if (isAll && session_status === 'LIVE' && isDisabledCall) {
        return false
      }

      if (isAll && overall_immersion) {
        dispatch({
          type: actionTypes.UPDATE_OVERAL_IMMMERSION,
          payload: {
            immersion: overall_immersion?.data,
            safety: overall_safety?.data,
          }
        });
      }

      if (immersion.data?.length === 0) {
        dispatch(updateFullLoadAnalysis(true));
      }

      if (immersion.data.data.length > 0) {

        dispatch({
          type: actionTypes.GET_ALL_GRAPHIC_DATA,
          payload: {
            activeParticipant: name,
            immersion: immersion.data ?
              {
                ...immersion.data,
                overall_index: overall_immersion?.data.immersion_index,
                overall_color_indicator: overall_immersion?.data.color_indicator,
                overall_context_indicator: overall_immersion?.data.context_indicator
              } : [],
            safety: safety,
            // pills: [],
            pills: pills?.data,
            overall_safety: overall_safety?.data,
            overall_immersion: overall_immersion?.data,
            isTag: isTag,
            status: session_status === 'COMPLETED'
          },
          loadingType: {
            isAll,
            isTag,
            isFilter,
            identifier: request.identifiers
          }
        });
      }

      setTimeout(() => {
        dispatch(setFetchingScores(false));
      }, 3000);
    } catch (e) {
      dispatch(setLoading(false));
      dispatch(setFetchingScores(false));
    }

  }
};

export const getSessionRange = (
  start: number,
  end: number,
) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: actionTypes.GET_SESSION_RANGE,
        payload: { start, end }
      });
    } catch (e) { }
  }
};

export const fetchSessionMarker = (client: any, request: any) => {
  return (dispatch: any) => {
    const variables = { ...request };
    client.query({
      query: ImmersionGQL.queryFetchSessionMarker,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      dispatch({
        type: actionTypes.GET_FETCH_SESSION_MARKERS,
        payload: res.data.fetchSessionMarker
      });

    }).catch(() => {

    })
  }
};

export const removeMarker = (client: any, req: any) => {
  return () => {
    const variables = { ...req };
    client.mutate({
      mutation: ImmersionGQL.mutationRemoveMarker,
      fetchPolicy: "no-cache",
      variables
    })
  }
};

export const updateMarker = (client: any, req: any, cb: any) => {
  return () => {
    const variables = { ...req };
    client.mutate({
      mutation: ImmersionGQL.mutationUpdateMarker,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      if (cb)
        cb(res.data);
    }).catch(() => {
    })
  }
};

export const addSegmentAsClip = (
  request: any,
  tenant_id: string,
  stimulusId: string, //session_code case of MODERATED
  cb: any
) => {
  return async (dispatch: any) => {
    try {
      const res = await apiClient(true).put(`/stimulus/v2/stimulus/segments/${tenant_id}/${stimulusId}`, { ...request })
      dispatch({
        type: actionTypes.PUT_SEGMENT_AS_CLIP,
        payload: res.data
      });
      cb(true);
    } catch (e: any) {
      cb(false);
    }
  }
};

export const onCallClipAPI = (
  request: any,
  tenant_id: string,
  stimulusId: string, // session_code case of MODERATED
  cb: any
) => {
  return async (dispatch: any) => {
    try {
      const res = await apiClient(true).post(`/stimulus/v2/stimulus/clips/${tenant_id}/${stimulusId}`, { ...request });
      dispatch({
        type: actionTypes.CLIP_SUCCESS,
        payload: res.data
      });
      cb(res.data);
    } catch (e) {
      cb(false);
    }
  }
};

export const onCallDeleteClipAPI = (
  params: any,
  cb: any
) => {
  return async (dispatch: any) => {
    const { tenant_id, stimulus_id, clip_id, session_code, session_type, search } = params;
    try {
      let res: any;
      if (session_type === 'ASYNC') {
        res = await apiClient(true).delete(
          `/stimulus/v2/stimulus/clips/async/${tenant_id}/${session_code}/${stimulus_id}/${clip_id}`
        );
      } else {
        res = await apiClient(true).delete(
          `/stimulus/v2/stimulus/clips/sync/${tenant_id}/${session_code}/${clip_id}`
        );
      }
      res.data.session_code = session_code;

      if (search) {
        dispatch({
          type: actionTypes.DELETE_SEARCH_CLIP_SUCCESS,
          payload: res.data
        });
      } else {
        dispatch({
          type: actionTypes.DELETE_CLIP_SUCCESS,
          payload: res.data
        });
      }

      cb(true);
    } catch (e) {
      cb(false);
    }
  }
};

export const onCallRenameClipAPI = (
  request: any,
  params: any,
  cb: any
) => {
  return async (dispatch: any) => {
    try {
      const { tenant_id, session_code, session_type, clip_id, stimulus_id, search } = params;
      let res: any;
      if (session_type === 'ASYNC') {
        res = await apiClient(true).patch(
          `/stimulus/v2/stimulus/clips/async/${tenant_id}/${session_code}/${stimulus_id}/${clip_id}`,
          { ...request }
        );
      } else {
        res = await apiClient(true).patch(
          `/stimulus/v2/stimulus/clips/sync/${tenant_id}/${session_code}/${clip_id}`,
          { ...request }
        );
      }
      res.data.session_code = session_code;
      res.data.clip_id = clip_id;

      if (search) {
        dispatch({
          type: actionTypes.CLIP_SEARCH_RENAME_SUCCESS,
          payload: res.data
        });
      } else {
        dispatch({
          type: actionTypes.CLIP_RENAME_SUCCESS,
          payload: res.data
        });
      }
      cb(true);
    } catch (e) {
      cb(false);
    }
  }
};

export const onGetClipInfo = (params: any, cb: any) => {
  return async () => {
    const { tenant_id, clip_id, session_code } = params;
    try {
      const res: any = await apiClient(true).get(`/analysis/v2/clips/${tenant_id}/${session_code}/${clip_id}`);
      cb(res);
    } catch (e) {
      cb(false);
    }
  }
};

export const getSegmentAsClip = (
  tenant_id: string,
  stimulusId: string, //session_code case of MODERATED
) => {
  return async (dispatch: any) => {
    try {
      const res = await apiClient(true).get(`/stimulus/v2/stimulus/segments/${tenant_id}/${stimulusId}`)
      dispatch({
        type: actionTypes.GET_SEGMENT_AS_CLIP,
        payload: res.data
      });
    } catch (e: any) {

    }
  }
};

export const getSafetyOverallSuccess = (data: any) => ({
  type: actionTypes.GET_SAFETY_OVERALL,
  payload: data
});

export const getSafetyOverall = (request: any, tenantId: string, session_code: string, type: string, status: string) => {
  return async (dispatch: any) => {
    try {
      const res = await apiClient(true).post(`/${status}/v2/${type}/index/safety/${tenantId}/${session_code}`, { ...request });
      if (res.data) {
        dispatch(getSafetyOverallSuccess(res.data));
      }
    } catch (error) {
      // dispatch(getSafetyOverallSuccess(null));
    }
  }
};

export const getImmersionOverallSuccess = (data: any) => ({
  type: actionTypes.GET_IMMERSION_OVERALL,
  payload: data
});

export const getImmersionOverall = (request: any, tenantId: string, session_code: string, type: string, status: string) => {
  return async (dispatch: any) => {
    try {
      const res = await apiClient(true).post(`/${status}/v2/${type}/index/immersion/${tenantId}/${session_code}`, { ...request });
      if (res.data) {
        dispatch(getImmersionOverallSuccess(res.data));
      }
    } catch (error) {
      // dispatch(getImmersionOverallSuccess(null));
    }
  }
};

export const getExcludedParticipants = (client: any, session_code: string | null) => {
  return (dispatch: any) => {
    if (session_code) {
      client.query({
        query: ImmersionGQL.queryGetExcludedParticipantsBySessionCode,
        fetchPolicy: "no-cache",
        variables: {
          session_code
        }
      }).then((res: any) => {
        if (res.data && res.data.getExcludedParticipantsBySessionCode) {
          dispatch(getExcludedParticipantsSuccess(res.data.getExcludedParticipantsBySessionCode));
        }
      }).catch(() => { })
    }
  }
};

export const getExcludedParticipantsCallBack = (client: any, session_code: string | null, cb: any) => {
  return (dispatch: any) => {
    if (session_code) {
      client.query({
        query: ImmersionGQL.queryGetExcludedParticipantsBySessionCode,
        fetchPolicy: "no-cache",
        variables: {
          session_code
        }
      }).then((res: any) => {
        if (res.data && res.data.getExcludedParticipantsBySessionCode) {
          dispatch(getExcludedParticipantsSuccess(res.data.getExcludedParticipantsBySessionCode));
          cb(res.data.getExcludedParticipantsBySessionCode);
        }
      }).catch(() => {
        cb(null)
      })
    }
  }
};

export const excludeParticipants = (client: any, req: any, cb: any) => {
  return () => {
    const variables = { ...req };
    client.mutate({
      mutation: ImmersionGQL.mutationExcludeParticipants,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      cb(res.data.excludeParticipants)
      // dispatch(getExcludedParticipantsSuccess(res.data.getExcludedParticipantsBySessionCode));
    }).catch((e: any) => {
      cb(e)
    })
  }
};

// update experience status from upcoming to live
export const liveExperience = (experience: any, req: any, cb: any) => {
  return () => {
    const variables = {
      user_id: req.user_id,
      session_id: req.session_id
    };
    experience.mutate({
      mutation: ImmersionGQL.mutationliveExperience,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      if (res.data.liveExperience.data) {
        cb(res.data.liveExperience.data)
      }
    }).catch((error: any) => {
      throw error;
    })
  }
};

export const completeExperience = (experience: any, req: any, cb: any) => {
  return () => {
    const variables = {
      user_id: req.user_id,
      session_id: req.session_id
    };
    experience.mutate({
      mutation: ImmersionGQL.mutationCompleteExperience,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      if (res.data.completeExperience.data) {
        cb(res.data.completeExperience.data)
      }
    }).catch((error: any) => {
      throw error;
    })
  }
};

export const getAllAnalysisAsync = async (
  request: any,
  tenant_id: number,
  session_code: string,
  name: string,
  isTag: boolean,
  backgroundLoading: boolean,
  cliped?: any
) => {
  return async (dispatch: any) => {
    const clipedRequest = { ...request, from_clip: UtilService.calcVideoEnd(cliped?.start_clip), to_clip: UtilService.calcVideoEnd(cliped?.end_clip) };

    dispatch(setLoading(backgroundLoading ? 'backgroundLoading' : name === 'All' ? 'all' : isTag ? name : request.identifiers[0]));

    try {

      let immersion = null;
      let safety = null;
      let overall_safety = null;
      let pills = null;

      const overall_immersion = await apiClient(true).post(`/analysis/v2/async/index/immersion/${tenant_id}/${session_code}`, { ...cliped ? clipedRequest : request });

      [immersion, safety, overall_safety, pills] = await Promise.all([
        apiClient(true).post(`/analysis/v2/async/immersion/${tenant_id}/${session_code}`, { ...request }),
        apiClient(true).post(`/analysis/v2/async/psych-readiness/${tenant_id}/${session_code}`, { ...request }),
        apiClient(true).post(`/analysis/v2/async/index/safety/${tenant_id}/${session_code}`, { ...cliped ? clipedRequest : request }),
        apiClient(true).post(`/analysis/v2/async/pills/${tenant_id}/${session_code}`, { ...request }),
      ]);

      if (immersion.data.data.length > 0) {
        dispatch({
          type: actionTypes.GET_ALL_GRAPHIC_DATA,
          payload: {
            activeParticipant: name,
            immersion: {
              ...immersion.data,
              overall_index: overall_immersion?.data.immersion_index,
              overall_color_indicator: overall_immersion?.data.color_indicator,
              overall_context_indicator: overall_immersion?.data.context_indicator
            },
            safety: safety?.data,
            pills: pills?.data,
            overall_safety: overall_safety?.data,
            isTag: isTag,
            isLiveAsyncAll: name === 'All',
            status: true
          }
        });
      }
      dispatch(setLoading(false));
    } catch (e) {
      dispatch(setLoading(false));
      dispatch(updateFullLoadAnalysis(true));
    }
  }
};
// IMM-4334
export const getAllAnalysisPills =  (
  request: any,
  tenant_id: number,
  session_code: string,
  MOD: boolean
) => {
  return async (dispatch: any) => {
    try {
      const pills = await apiClient(true).post(`/analysis/v2/${MOD ? 'sync' : 'async'}/pills/${tenant_id}/${session_code}`, { ...request })
      dispatch({
        type: actionTypes.UPDATE_ALL_PARTICIPANT_PILLS,
        payload: pills?.data
      });
    } catch (e) {

    }
  }
};

export const getAsyncImmersionOverall = (request: any) => {
  return async (dispatch: any) => {
    try {
      const { tenant_id, session_code } = request;
      const res = await apiClient(true).post(`/analysis/v2/async/index/immersion/${tenant_id}/${session_code}`, { ...request });
      if (res.data && res.data?.immersion_index) {
        dispatch(getImmersionOverallSuccess(res.data));
      }
    } catch (error) {
      // dispatch(getImmersionOverallSuccess(null));
    }
  }
};

export const getAsyncSafetyOverall = (request: any) => {
  return async (dispatch: any) => {
    try {
      const { tenant_id, session_code } = request;
      const res = await apiClient(true).post(`/analysis/v2/async/index/safety/${tenant_id}/${session_code}`, { ...request });
      if (res.data && res.data?.safety_index) {
        dispatch(getSafetyOverallSuccess(res.data));
      }
    } catch (error) {
      // dispatch(getSafetyOverallSuccess(null));
    }
  }
};

export const exportXLSX = (request: any, cb: any) => {
  return async () => {
    try {
      const { tenant_id, session_code } = request;
      const res = await apiClient(true).get(`/analysis/v2/export/${tenant_id}/${session_code}`, { ...request });
      if (res && res.data && res.data.status === 'SUCCESS') {
        cb(res.data.export_url)
      } else {
        cb(false)
      }
    } catch (error) {
      cb(false)
    }
  }
};

export const exportExperiencesAsZip = (tenantId: string, payload: any, callback: any) => {
  return async () => {
    try {
      const res = await apiClient(true).post(`/analysis/v2/export/${tenantId}`, {...payload});
      if (res && res.data && res.data.status === 'SUCCESS') {
        callback(res.data.export_url);
      } else {
        callback(null)
      }
    } catch (e) {
      callback(null)
    }
  }
};

export const getStimulusAnalysis = (payload: any) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: actionTypes.GET_STIMULUS_ANALYSIS,
        payload
      });
    } catch (e: any) {

    }
  }
};

export const updateTrimTime = (client: any, req: any, cb: any) => {
  return () => {
    const variables = { ...req };
    client.mutate({
      mutation: ImmersionGQL.mutationUpdateTrimTime,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      cb(res.data.updateTrimTime);
    }).catch(() => {

    })
  }
};

export const getNorm = (client: any, req: any, cb: any) => {
  return () => {
    const variables = { ...req };
    client.query({
      query: ImmersionGQL.queryGetNorm,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      cb(res.data);
    }).catch(() => {
    })
  }
}

export const getNorm2 = (client: any, req: any, cb: any) => {
  return () => {
    client.query({
      query: ImmersionGQL.queryOverviewNew,
      fetchPolicy: "no-cache",
      variables: { session_code: req.session_code }
    }).then((res: any) => {
      if (res.data.getOverviewData) {
        const mainData = res.data.getOverviewData
        if (cb)
          cb(mainData);
      }
    }).catch(() => {
    })
  }
};

export const getShareLink = (client: any, req: any, cb: any) => {
  return () => {
    const variables = { ...req };
    client.query({
      query: ImmersionGQL.queryGetShareLink,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      if (cb)
        cb(res.data);
    }).catch(() => {
      cb(null)
    })
  }
};

export const updateUserAttributesAnalyze = (client: any, req: any) => {
  return () => {
    client.mutate({
      mutation: ImmersionGQL.mutationUpdateUserAttributes,
      fetchPolicy: "no-cache",
      variables: req
    })
      .then(() => {

      }).catch(() => {

      })
  }
}

export const getUrlEncodeConvert = (client: any, req: any, cb: any) => {
  return () => {
    client.mutate({
      mutation: ImmersionGQL.mutationUrlEncodeConvert,
      fetchPolicy: "no-cache",
      variables: req
    })
      .then((res: any) => {
        if (res?.data?.urlEncodeConvert) {
          cb(res?.data?.urlEncodeConvert)
        }
      }).catch(() => {

      })
  }
}